import React, { Component } from 'react';
import { Form, Input, Modal, Radio, Select } from 'antd';
import { queryBudgetGroupInfo } from '@api/finance/budget';

const FormItem = Form.Item;
const { Option } = Select;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: {},
      isProject: false,
      managerUuid: '',
      workOrgUuids: [],
      viewUsersUuids: [],
      workOrgs: props.workOrgs,
      users: props.users,
      books: props.books,
    };
  }

  componentDidMount() {
    const { uuid } = this.props;
    if (uuid) {
      this.loadDetail(uuid);
    }
  }

  submit = e => {
    if (e) {
      e.preventDefault();
    }
    const { handSubmit } = this.props;
    const capital = this.props.form.getFieldsValue();
    !capital.bookUuid && (capital.bookUuid = '');
    capital.managerName = this.dealManager(capital.managerUuid);
    capital.isProject = this.state.isProject ? 1 : 0;
    capital.viewUsers = this.dealView(capital.viewUsers);
    capital.bookName = this.dealBook(capital.bookUuid);

    if (this.props.uuid) {
      capital.uuid = this.props.uuid;
    }
    if (capital.isProject === 1) {
      capital.workOrgs = this.dealView(capital.workOrgs);
    } else {
      capital.workOrgs = this.dealWorkOrg(capital.workOrgs);
    }
    this.props.form.validateFields(err => {
      if (!err) {
        handSubmit(capital);
      }
    });
  };

  // 设置负责人name
  dealManager = managerUuid => {
    const usersAll = this.props.users;
    let managerName = '';
    usersAll.map(item => {
      if (item.uuid === managerUuid) {
        managerName = item.name;
      }

      return 1;
    });

    return managerName;
  };

  // 设置可查看人员name
  dealView = users => {
    const params = [];
    const usersAll = this.props.users;
    for (let i = 0; i < usersAll.length; i++) {
      for (let j = 0; j < users.length; j++) {
        if (usersAll[i].uuid === users[j]) {
          params.push(usersAll[i]);
        }
      }
    }
    return params;
  };

  // 设置关联人员name
  dealWorkOrg = users => {
    const params = [];
    const usersAll = this.props.workOrgs;
    for (let i = 0; i < usersAll.length; i++) {
      for (let j = 0; j < users.length; j++) {
        if (usersAll[i].uuid === users[j]) {
          params.push(usersAll[i]);
        }
      }
    }
    return params;
  };

  // 设置资金账户name
  dealBook = books => {
    const booksAll = this.props.books;
    for (let i = 0; i < booksAll.length; i++) {
      if (booksAll[i].uuid === books) {
        return `${booksAll[i].companyName}(${booksAll[i].remark})`;
      }
    }
  };

  loadDetail = uuid => {
    queryBudgetGroupInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        const workOrgUuids = [];
        const viewUsersUuids = [];
        // 设置总的业务部门
        const { workOrgs } = this.props;
        const { users } = this.props;
        // .concat(res.data.workOrgs);
        // users = this.props.users.concat(res.data.viewUsers);

        res.data.workOrgs.map(item => {
          workOrgUuids.push(item.uuid);
          return workOrgUuids;
        });
        res.data.viewUsers.map(item => {
          viewUsersUuids.push(item.uuid);
          return viewUsersUuids;
        });
        this.setState({
          content: res.data,
          isProject: res.data.isProject === 1,
          managerUuid: res.data.managerUuid,
          workOrgUuids,
          viewUsersUuids,
          workOrgs,
          users,
        });
      }
    });
  };

  handleRadio = () => {
    this.props.form.resetFields(['workOrgUuids']);
    const { isProject } = this.state;
    this.setState({
      isProject: !isProject,
    });
    this.props.form.setFieldsValue({ workOrgs: [] });
  };

  handleBookName = () => {};

  render() {
    const { getFieldDecorator } = this.props.form;
    const { isProject, workOrgUuids, workOrgs, users, managerUuid, viewUsersUuids, books } =
      this.state;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const { content } = this.state;
    return (
      <Modal title={this.props.title} visible onOk={this.submit} onCancel={this.props.cancel}>
        <Form>
          <FormItem label="预算组名称" {...formItemLayout}>
            {getFieldDecorator('name', {
              rules: [{ required: true, message: '请输入账户名称' }],
              initialValue: content.name,
            })(<Input />)}
          </FormItem>
          <FormItem label="项目预算" {...formItemLayout}>
            {getFieldDecorator('isProject', {
              initialValue: content.isProject !== 0,
            })(<Radio onClick={this.handleRadio} checked={isProject} />)}
          </FormItem>
          <FormItem label="预算负责人" {...formItemLayout}>
            {getFieldDecorator('managerUuid', {
              initialValue: managerUuid,
            })(
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {users.map((item, index) => {
                  return <Option key={item.uuid}>{item.name}</Option>;
                })}
              </Select>,
            )}
          </FormItem>
          <FormItem label="可以查看人员" {...formItemLayout}>
            {getFieldDecorator('viewUsers', {
              initialValue: viewUsersUuids,
            })(
              <Select
                mode="multiple"
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {users.map((item, index) => {
                  return <Option key={item.uuid}>{item.name}</Option>;
                })}
              </Select>,
            )}
          </FormItem>
          {isProject ? (
            <FormItem label="关联人员" {...formItemLayout}>
              {getFieldDecorator('workOrgs', {
                initialValue: workOrgUuids,
              })(
                <Select
                  mode="multiple"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {users.map((item, index) => {
                    return <Option key={item.uuid}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          ) : (
            <FormItem label="关联业务部门" {...formItemLayout}>
              {getFieldDecorator('workOrgs', {
                initialValue: workOrgUuids,
              })(
                <Select
                  mode="multiple"
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {workOrgs.map((item, index) => {
                    return <Option key={item.uuid}>{item.name}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          )}
          <FormItem label="关联资金账户" {...formItemLayout}>
            {getFieldDecorator('bookUuid', {
              initialValue: content.bookUuid,
            })(
              <Select
                allowClear
                filterOption={(input, option) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onSelect={this.handleBookName}
                dropdownStyle={{ width: '500px' }}
                dropdownMatchSelectWidth={false}
                dropdownClassName="bookList"
              >
                {books.map((item, index) => {
                  return <Option key={item.uuid}>{`${item.companyName}(${item.remark})`}</Option>;
                })}
              </Select>,
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(IndexModal);



// WEBPACK FOOTER //
// ./src/components/finance/budget/ModalAdd.js